module.exports = __webpack_public_path__ + "/font/fontawesome-webfont_7810.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.eot
 ** module id = 473
 ** module chunks = 0
 **/